<template>
    <div v-if="json" class="social-block" :class="(isHome) ? 'home' : 'not'">
        <div class="capper">
            <div class="capper-padded-2x">
                <div class="social-icons" data-aos="fade-up" >
                    <div v-if="isHome" class="first ">
                        <router-link class="socicon-a" to="/community" aria-label="Community" >
                        <span>Explore the Community</span>
                        </router-link>
                    </div>
                    <div v-else class="first ">
                        <span>Explore the Community</span>
                    </div>
                    <template v-for="(socialItem, index) in json.contact.social">
                        <div v-if="socialItem" :key="`social${index}`" :class="`icon`">
                            <!-- Iterate over each social media platform (e.g., facebook, instagram) -->
                            <a

                                :key="`link-${index}`"
                                :class="`socicon-a ${index}`"
                                :href="socialItem.link"
                                target="_blank"
                                data-aos="fade-up"
                                :aria-label="socialItem.type"
                            >
                                <!-- Load SVG based on platform name -->
                                <component :is="getSvg(socialItem.type)" class="icon-svg" />
                            </a>
                        </div>
                    </template>
                </div>

            </div>
        </div>
    </div>
</template>

<script>
import Facebook from "@/components/svgs/Facebook.vue";
import Instagram from "@/components/svgs/Instagram.vue";
import Twitter from "@/components/svgs/Twitter.vue";
import Youtube from "@/components/svgs/Youtube.vue";
import Linkedin from "@/components/svgs/Linkedin.vue";
import Discord from "@/components/svgs/Discord.vue";
import Reddit from "@/components/svgs/Reddit.vue";
import Snapchat from "@/components/svgs/Snapchat.vue";
import Tiktok from "@/components/svgs/Tiktok.vue";
import Twitch from "@/components/svgs/Twitch.vue";
import Bluesky from "@/components/svgs/Bluesky.vue";

export default {
    name: "SocialBlock",
    props: {
        isHome: {
            type: Boolean,
            required: false,
            default: false
        },
    },
    data() {
        return {
            window: window,
            json: null,
        };
    },

    mounted() {
        // Assuming the json comes from global config
        this.json = this.window.config.json.global;
    },
    methods: {
        // Method to dynamically return the SVG file path based on the social media platform (e.g., facebook, instagram)
        getSvg(platform) {
            platform = String(platform).toLowerCase();
            switch (platform) {
                case "facebook":
                    return Facebook;
                case "instagram":
                    return Instagram;
                case "twitter":
                case "x":
                    return Twitter;
                case "youtube":
                    return Youtube;
                case "linkedin":
                    return Linkedin;
                case "discord":
                    return Discord;
                case "reddit":
                    return Reddit;
                case "snapchat":
                    return Snapchat;
                case "tiktok":
                    return Tiktok;
                case "twitch":
                    return Twitch;
                case "bluesky":
                    return Bluesky;
                default:
                    return null;
            }
        }
    },
};
</script>